import { useCallback } from 'react';

import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useDeleteLocation(): UseMutationResult<
  AxiosResponse<null>,
  AxiosError<ErrorMessage>,
  string
> {
  const queryClient = useQueryClient();

  const deleteLocation = useCallback((locationId: string): Promise<AxiosResponse<null>> => {
    return client.delete(`locations/${locationId}/`);
  }, []);

  return useMutation(deleteLocation, {
    onSuccess: () => {
      queryClient.removeQueries('locations');
    },
  });
}
